<script lang="ts" setup>
import { ru } from '@nuxt/ui/locale'

import { useCookieModal } from './composables/cookie/useCookieModal'

// Vite `?url` must stay in this SFC — Nitro cannot resolve it from shared `.ts` (see brand/assets.ts).
import fontRegularUrl from '~/app/assets/brand/fonts/IbmPlexMono/IBMPlexMono-Regular.ttf?url'

const { cookieModal: CookieModal } = useCookieModal({
  delay: 10e3,
})

useHead({
  link: [
    {
      rel: 'preconnect',
      href: 'https://storage.yandexcloud.net',
    },
    {
      rel: 'preload',
      as: 'font',
      fetchpriority: 'high',
      type: 'font/ttf',
      href: fontRegularUrl,
      crossorigin: 'anonymous',
    },
  ],
})

// canonical задаёт модуль Seo (plugins/seoRoot.ts)
</script>

<template>
  <UApp :locale="ru" :toaster="{ position: 'top-right' }">
    <CookieModal />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
